import { render, staticRenderFns } from "./commitRecord.vue?vue&type=template&id=f88df73a&scoped=true&"
import script from "./commitRecord.vue?vue&type=script&lang=js&"
export * from "./commitRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88df73a",
  null
  
)

export default component.exports